import grant from './grant'
import nodetoken from './nodetoken'
import field from './field'
import nodelock from './nodelock'

export default {
  namespaced: true,
  modules: {
    grant,
    nodetoken,
    field,
    nodelock,
  }
}
